import React, { useRef, useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import {
  formatRegisterDobInput,
  REGISTER_DOB_FORMAT,
} from "../Register/Register.validator";

const RegistrationDobField = ({
  id,
  name,
  value = "",
  onChange,
  onBlur,
  placeholder = REGISTER_DOB_FORMAT,
  className = "",
  disabled = false,
}) => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const pickerWrapRef = useRef(null);

  const disabledDobDate = (current) => {
    if (!current) {
      return false;
    }
    return (
      current.isAfter(moment(), "day") ||
      current.isBefore(moment("01/01/1900", REGISTER_DOB_FORMAT), "day")
    );
  };

  const handleInputChange = (event) => {
    const formatted = formatRegisterDobInput(event.target.value);
    onChange?.(formatted, { name, touched: true });
  };

  const handleCalendarChange = (date) => {
    if (!date || !moment(date).isValid()) {
      return;
    }
    onChange?.(moment(date).format(REGISTER_DOB_FORMAT), {
      name,
      touched: true,
    });
    setCalendarOpen(false);
  };

  const calendarValue =
    value && moment(value, REGISTER_DOB_FORMAT, true).isValid()
      ? moment(value, REGISTER_DOB_FORMAT)
      : null;

  return (
    <div className="reg-dob-field" ref={pickerWrapRef}>
      <input
        id={id}
        name={name}
        type="text"
        className={`form-input reg-dob-input${className ? ` ${className}` : ""}`}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        onBlur={() => onBlur?.({ target: { name } })}
        disabled={disabled}
        autoComplete="bday"
        inputMode="numeric"
      />
      {!disabled && (
        <>
          <button
            type="button"
            className="reg-dob-calendar-btn"
            aria-label="Open calendar"
            aria-expanded={calendarOpen}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setCalendarOpen(true);
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
          </button>
          <DatePicker
            className="reg-dob-picker-hidden"
            open={calendarOpen}
            onOpenChange={setCalendarOpen}
            value={calendarValue}
            onChange={handleCalendarChange}
            disabledDate={disabledDobDate}
            format={REGISTER_DOB_FORMAT}
            allowClear={false}
            inputReadOnly
            showToday
            dropdownClassName="reg-dob-datepicker-dropdown"
            getPopupContainer={() =>
              pickerWrapRef.current || document.body
            }
          />
        </>
      )}
    </div>
  );
};

export default RegistrationDobField;
